import {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";

export default function Matches() {
    const [loading, setLoading] = useState(true);
    const [matches, setMatches] = useState([]);
    const navigate = useNavigate();

    function convertTZtoHumanReadable(tzTime) {
        // Create a Date object with the provided TZ time
        const date = new Date(tzTime);

        // Get the year, month, day, hours, minutes, and seconds
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // Construct the human-readable time string
        const humanReadableTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

        return humanReadableTime;
    }

    function handleClick(id) {
        navigate(`pronos/${id}`);
    }

    const fetchAllMatches = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/matchs/`).then((resp) => {
            console.log(resp)
            setLoading(false);
            setMatches(resp.data)
        }).catch((err) => {
            alert(err)
        })
    };

    useEffect(() => {
        fetchAllMatches();
    }, []);

    return (
        <div>
            {
                loading ?
                    <div className={"flex flex-col items-center my-10"}>
                        <div
                            className="relative items-center block max-w-full p-6 bg-white border border-gray-100 rounded-lg shadow-md ">
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-black opacity-50">Récupération de
                                la liste des matchs</h5>
                            <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                                <svg aria-hidden="true"
                                     className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-pink-600"
                                     viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"/>
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"/>
                                </svg>
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div> : <div className="p-16 sm:px-10 lg:px-16">
                        <div className="sm:flex sm:items-center">
                            <div className="sm:flex-auto">
                                <h1 className="text-base font-semibold leading-6 text-gray-900">Matchs</h1>
                                <p className="mt-2 text-sm text-gray-700">
                                    A list of all the matchs and scores
                                </p>
                            </div>
                        </div>
                        <div className="mt-8 flow-root">
                            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                    <table className="min-w-full divide-y divide-gray-300">
                                        <thead>
                                        <tr>
                                            <th scope="col"
                                                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                                                Equipe 1
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Equipe 2
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Actif
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Date
                                            </th>
                                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                                                <span className="sr-only">Voir Pronotics</span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                        {matches.map((match) => (
                                            <tr key={match.id}>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                                                    {match.team_1}
                                                </td>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                                                    {match.team_2}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm font-bold"
                                                    style={{color: match.is_active == true ? 'green' : 'red'}}>{match.is_active == true ? 'Actif' : 'Inactif'}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{convertTZtoHumanReadable(match.scheduled_at)}</td>
                                                <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0"
                                                    onClick={() => handleClick(match._id)}>
                                                    <a href="#" className="text-indigo-600 hover:text-indigo-900">
                                                        Voir Pronos
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </div>

    )
}
